"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportExcludedProductsComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var papaparse_1 = __importDefault(require("papaparse"));
var react_csv_1 = require("react-csv");
var react_redux_1 = require("react-redux");
var doshx_controls_web_1 = require("doshx_controls_web");
var main_1 = require("../../../../../../reducers/slices/main");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var add_excluded_product_1 = require("../../../../../../api/calls/product/add_excluded_product");
var get_excluded_products_thunk_1 = require("../../../../../../reducers/slices/products/thunks/get_excluded_products_thunk");
var ImportExcludedProductsComponent = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)([]), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var excludedProductsPagination = (0, react_redux_1.useSelector)(function (state) { return state.productState; }).excludedProductsPagination;
    var csvSampleData = [
        [
            "title",
            "sku",
            "pid",
            "barcode", //required
        ],
        ["Driftaway Double Bed Mattress Topper", "6009534939934", "54657", "6009534939934"],
    ];
    var handleFileUpload = function (e) {
        var file = e.target.files[0];
        papaparse_1.default.parse(file, {
            header: true,
            complete: function (results) {
                var normalizedData = results.data.map(function (row) {
                    var normalizedRow = {};
                    Object.keys(row).forEach(function (key) {
                        if (key) {
                            normalizedRow[key.toLowerCase()] = row[key];
                        }
                    });
                    return normalizedRow;
                });
                setData(normalizedData);
            },
            skipEmptyLines: true,
        });
    };
    return ((0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ className: "shadow-2xl border-dashed", variant: "outlined", borderColor: "border-black", backgroundColor: "bg-transparent" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "gap-4 w-[500px] h-[200px]" }, { children: [isLoading && (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "large" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "mb-4 border-dashed border-blue-600" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Download Sample CSV Template", bold: true, textColor: "text-black" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-blue-500 mt-4" }, { children: (0, jsx_runtime_1.jsxs)(react_csv_1.CSVLink, __assign({ data: csvSampleData, filename: "sampleProductsTemplate", target: "_blank" }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowDown }), " Sample CSV Template"] })) }))] })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.BoxControl, __assign({ className: "shadow-2xl border-dashed" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: " gap-4 border-separate border-dotted" }, { children: (0, jsx_runtime_1.jsx)("input", { type: "file", accept: ".csv", onChange: handleFileUpload, className: "border-dashed" }) })) }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { enabled: (data === null || data === void 0 ? void 0 : data.length) ? true : false, iconColor: "text-white", label: "Add Excluded Products", size: "small", backgroundColor: "bg-primary", textColor: "text-white", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setIsLoading(true);
                                    return [4 /*yield*/, (0, add_excluded_product_1.add_excluded_products)(data)];
                                case 1:
                                    response = _a.sent();
                                    if (response.success) {
                                        setIsLoading(false);
                                        dispatch((0, main_1.setMessageModal)({ title: "Successfully uploaded excluded products.", messages: [response.message] }));
                                        dispatch((0, get_excluded_products_thunk_1.get_excluded_products_thunk)(__assign({}, excludedProductsPagination)));
                                    }
                                    else {
                                        setIsLoading(false);
                                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when importing products.", messages: [response.message] }));
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); } }) }))] })));
};
exports.ImportExcludedProductsComponent = ImportExcludedProductsComponent;
